import { styled } from '@mui/material/styles';

interface WrapperProps {
  isDragging?: boolean;
  isDragOver?: boolean;
  editMode?: boolean;
}

export const Wrapper = styled('div')<WrapperProps>(
  ({ theme, isDragging, isDragOver, editMode }) => `
    position: relative;
    width: 100%;
    border-radius: 24px;
    transition: opacity 0.15s ease, outline-color 0.15s ease, box-shadow 0.2s ease;
    opacity: ${isDragging ? 0.4 : 1};
    outline: 2px solid ${isDragOver ? theme.palette.primary.main : 'transparent'};
    outline-offset: 4px;
    ${editMode ? `box-shadow: 0 0 0 1px ${theme.palette.primary.main}33 inset;` : ''}
  `
);

export const DragHandle = styled('div')`
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  cursor: grab;
  color: ${({ theme }) => theme.palette.white['06']};
  background: transparent;
  transition:
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.palette.white['01']};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  &:active {
    cursor: grabbing;
  }
`;
